import { reactive } from 'vue'
import actions from '@/store/user/actions'
import state from '@/store/user/state'
import getters from '@/store/user/getters'

export const userModule = {
    state: reactive(state),
    actions,
    getters,
}
